import React from 'react'
import { InformationListProps } from './types'
import styles from './InformationList.module.scss'
import { formatDate } from 'javascripts/common/format'
import { Button } from '../v2/Button'
import { useIsMobile } from 'spa/member/hooks/v2/useScreenSize'

const getBadgeText = (category: string) => {
  switch (category) {
    case 'information':
      return 'お知らせ'
    case 'release':
      return 'リリース'
    case 'event':
      return '特集・イベント'
    case 'media':
      return 'メディア掲載'
    case 'other':
      return 'その他'
    default:
      return category;
  }
}

export const StyledInformationList: React.FC<InformationListProps> = props => {
  const isMobile = useIsMobile()

  if (props.informationList.length === 0) {
    return null
  }

  return (
    <section className={`flex flex-col justify-center items-center ${styles.container} ${props.className || ''}`}>
      <h2 className="text-L font-bold pb-XL tablet:text-3XL tablet:pb-4XL">お知らせ</h2>
      {props.informationList.map(info => (
        <div className={`flex flex-col w-full p-M gap-XS border-t-1 border-member-gray-20 ${styles.info}`} key={info.id}>
          <div className="flex gap-S">
            <span className="text-XS">{formatDate(info.informedOn)}</span>
            {/* TODO: Badgeコンポーネントができたら入れ替える */}
            <span className="inline-flex justify-center items-center border-1 text-2XS font-bold rounded-full px-XS border-member-green-100 text-member-green-100"
            style={{ height: '18px' }}>
              {getBadgeText(info.category)}
            </span>
          </div>
          <a className={`text-S tablet:text-M ${styles.link}`} href={`/information/${info.id}`}>
            {info.title}
          </a>
        </div>
      ))}
      <a href="/information" className="mt-L tablet:mt-2XL">
        <Button buttonType={isMobile ? 'SMALL' : 'DEFAULT'} link>お知らせ一覧を見る</Button>
      </a>
    </section>
  )
}
